import React, { useEffect } from "react";
import { createPortal } from "react-dom";

const el = document.createElement("div");

function RightSidebar({ children, isOpen }) {
  useEffect(() => {
    const elRightSidebar = document.getElementById("rightSidebar");
    elRightSidebar.appendChild(el);

    return () => {
      elRightSidebar.removeChild(el);
    };
  }, []);

  return createPortal(
    <div
      style={{
        width: 350,
        position: "relative",
        marginRight: isOpen ? 0 : -350,
        transition: "margin 100ms ease-in-out",
        zIndex: 1005,
      }}
    >
      {isOpen ? children : undefined}
    </div>,
    el
  );
}

export default RightSidebar;
